import React from 'react';
import {observer, inject} from 'mobx-react';
import {makeObservable} from 'mobx';

import {PropTypes} from 'prop-types';

import {withRouter} from '../core/withRouter';

import {LoadingIndicator} from '../components/loading-indicator/loading-indicator.jsx';
import {NewAppLoading} from '../components/new-application/new-app-loading.jsx';
import NewAppNamePlatform from '../components/new-application/new-app-name-platform.jsx';
import NewAppProgressBar from '../components/new-application/new-app-progress-bar.jsx';
import {NewAppDetails} from '../components/new-application/new-app-details.jsx';
import {NewAppPackage} from '../components/new-application/new-app-package.jsx';
import {NewAppScreenshots} from '../components/new-application/new-app-screenshots.jsx';
import {NewAppReview} from '../components/new-application/new-app-review.jsx';
import {NewAppSubmit} from '../components/new-application/new-app-submit.jsx';
import {NewAppSubmitInterstitial} from '../components/new-application/new-app-submit-interstitial.jsx';
import {NewAppConfirmation} from '../components/new-application/new-app-confirmation.jsx';
import {NewAppValidations} from '../components/new-application/new-app-validations.jsx';
import NewAppCancelContinueSubmit from '../components/new-application/new-app-cancel-continue-submit.jsx';
import {NewAppUnsavedChangesModal} from '../components/new-application/new-app-unsaved-changes-modal.jsx';

@inject('store')
@observer
class NewApplicationPage extends React.Component {

	static propTypes = {
		store: PropTypes.object.isRequired,
		match: PropTypes.object
	}

	get saveId() {
		return this.props.match.params.saveId
	}

	constructor(props) {
		super(props);
		makeObservable(this);
		this.masterStore = this.props.store;
		this.newAppMasterStore = this.props.store.newAppMasterStore;
		this.newAppMasterStore.discardChangesAndLeave = this.newAppMasterStore.discardChangesAndLeave.bind(this.newAppMasterStore);
		this.newAppMasterStore.saveChangesAndLeave = this.newAppMasterStore.saveChangesAndLeave.bind(this.newAppMasterStore);
		this.newAppMasterStore.stayAndKeepEditing = this.newAppMasterStore.stayAndKeepEditing.bind(this.newAppMasterStore);

		this.newAppDetailsStore = this.newAppMasterStore.newAppDetailsStore;
		this.newAppValidationsStore = this.newAppMasterStore.newAppValidationsStore;
		this.newAppUploadStore = this.newAppMasterStore.newAppUploadStore;
		this.newAppNamePlatformStore = this.newAppMasterStore.newAppNamePlatformStore;

		this.modalsStore = this.props.store.modalsStore;
		this.appDetailStore = this.props.store.appDetailStore;
		this.userName = this.props.store.userStore.fullName;
		this.newAppMasterStore.unsetTermsAgreement();
		this.newAppMasterStore.enableSaveDialogs();

		if (this.saveId) {
			this.newAppMasterStore.loadDraft(this.saveId);
		}
	}

	componentDidMount() {
		this.newAppMasterStore.getCategoriesAndSegments();
		this.newAppMasterStore.getAppCapabilities();
	}

	componentWillUnmount() {
		this.newAppMasterStore.clearNewAppData();
		this.newAppMasterStore.disableSaveDialogs();
		this.newAppUploadStore.resetFields();
		this.newAppDetailsStore.resetFields();
	}

	renderLoadingView () {
		return (
			<div>
				<NewAppLoading />
				<LoadingIndicator isLoading={this.newAppMasterStore.isLoading} />
			</div>
		);
	}

	render() {
		if(this.newAppMasterStore.isLoading) {
			return this.renderLoadingView();
		}
		const section = this.props.match.params.section;
		const canSaveChanges = Boolean(this.newAppMasterStore.newAppData.appName && this.newAppMasterStore.newAppData.platform);
		return (
			<div className="new-app-page">
				{(this.newAppMasterStore.showLoadingOverlay && <NewAppSubmitInterstitial store={this.newAppMasterStore} />)}
				<NewAppNamePlatform store={this.newAppNamePlatformStore} />
				<NewAppValidations store={this.newAppValidationsStore} />
				<NewAppProgressBar store={this.newAppMasterStore} disabled={this.newAppMasterStore.disableMainSection} />
				<div aria-hidden={this.newAppMasterStore.disableMainSection} className={`new-app-page-section-wrapper ${(this.newAppMasterStore.disableMainSection ? 'deactivated' : '')}`}>
					{section === 'app-details' && <NewAppDetails masterStore={this.masterStore} disabled={this.newAppMasterStore.disableMainSection} />}
					{section === 'app-package' && <NewAppPackage store={this.newAppUploadStore} disabled={this.newAppMasterStore.disableMainSection} />}
					{section === 'app-screenshots' && <NewAppScreenshots store={this.newAppUploadStore} disabled={this.newAppMasterStore.disableMainSection} />}
					{section === 'app-review' && <NewAppReview masterStore={this.masterStore} disabled={this.newAppMasterStore.disableMainSection} />}
					{section === 'app-submit' && <NewAppSubmit userName={this.userName} store={this.newAppMasterStore} disabled={this.newAppMasterStore.disableMainSection} />}
					{section === 'app-confirmation' && <NewAppConfirmation />}
				</div>
				<NewAppCancelContinueSubmit store={this.newAppMasterStore} disabled={this.newAppMasterStore.disableMainSection} />
				{(this.modalsStore.modalVisibilities.unsavedChanges && <NewAppUnsavedChangesModal
					discardChangesAndLeave={this.newAppMasterStore.discardChangesAndLeave}
					saveChangesAndLeave={this.newAppMasterStore.saveChangesAndLeave}
					stayAndKeepEditing={this.newAppMasterStore.stayAndKeepEditing}
					modalVisibilities={this.modalsStore.modalVisibilities}
					saveChangesAndLeaveEnabled={canSaveChanges} />)}
			</div>
		);
	}
}

const RoutedNewApplicationPage = withRouter(NewApplicationPage);
export { RoutedNewApplicationPage as NewApplicationPage };